import styled from "styled-components"
import variables from "../../../data/variables"

export const NavbarLogo = styled.div`
  a {
    color: ${variables.black};
    font-size: 2.3rem;
    font-family: ${variables.fontFamily};
    font-weight: bold;
  }
  @media (max-width: ${variables.breakpointPhone}) {
    display: none;
  }
`

export const NavbarElement = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  @media (max-width: ${variables.breakpointPhone}) {
    grid-template-columns: 1fr;
    text-align: center;
    width: 100%;
  }
`

export const NavbarList = styled.ul`
  padding-left: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  list-style: none;
  > li a {
    font-size: 1.1rem;
    color: #232323;
    padding: 0.5rem 0.2rem;
    margin: 0 1rem;
    text-decoration: none;
    vertical-align: middle;
    > svg {
      width: 18px;
      margin-right: 5px;
    }
    span,
    svg {
      display: inline-block;
      vertical-align: middle;
    }
    @media (max-width: ${variables.breakpointPhone}) {
      font-size: 1rem;
    }
  }
`
